import { PrintLabelContentViewModel } from '../print-label-content-view-model';
import { Injectable } from '@angular/core';
import { StrainType } from '../../../../../../models/enum/dto/strain-classification.enum';
import { map } from 'rxjs/operators';
import type { CardData } from '../../../../../../models/print-cards/card-data';
import { PrintCardColumnViewModel } from '../../../../../display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/print-card-column-view-model';

@Injectable()
export class Avery94200LabelStackContentViewModel extends PrintLabelContentViewModel {
  public readonly productAssetBackgroundColor$ = this.labelData$.pipe(
    map(labelData => this.getInventoryLabelStrainTypeColor(labelData?.getStrainType()))
  );

  protected getInventoryLabelStrainTypeColor(strainType: StrainType): string {
    switch (strainType) {
      case StrainType.Indica:
      case StrainType.IndicaDominant:
        return '#84D4ED';
      case StrainType.Sativa:
      case StrainType.SativaDominant:
        return '#FF393C';
      case StrainType.Hybrid:
      case StrainType.Blend:
        return '#F39020';
      case StrainType.CBD:
        return '#A3D55A';
      default:
        return '';
    }
  }

  protected override getExpandedGridSizeHelper(
    cardData: CardData,
    columnVM: PrintCardColumnViewModel,
    removeSpacing: boolean = true,
    upperCaseUnits: boolean = true
  ): string {
    const variant = columnVM?.variant;
    const size = cardData?.getGridQuantityAndSizeString(variant);
    const split = size?.split(' ');
    const lastIndex = split?.length - 1;
    if (lastIndex > -1 && upperCaseUnits) split[lastIndex] = split[lastIndex]?.toUpperCase();
    const splitLowerCased = split?.map(it => it?.toLowerCase());
    if (splitLowerCased?.includes('capsule') || splitLowerCased?.includes('capsules')) return split?.join(' ');
    return split?.join(removeSpacing ? '' : ' ');
  }
}
